<template lang="pug">
  div(class="user-details")
    h3(
      v-if="user.name"
      class="title-20px mb-6"
    ) {{ user.name }} -
      span(
        v-if="user.email"
        class="text-16px dark pl-1"
      ) {{ user.email }}
    e-tabs(:items="items")
</template>

<script>
import ETabs from '~/components/elements/tabs/e-tabs'

export default {
  name: 'MUserDetails',
  components: {
    ETabs
  },
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  computed: {
    items() {
      return [
        {
          text: this.$t('Documents'),
          component: 'block-admin-documents',
          componentProps: {
            entityId: this.user.id,
            filterName: 'participants.user.id'
          }
        },
        {
          text: this.$t('Sessions'),
          component: 'block-user-sessions',
          componentProps: {
            userId: this.user.id
          }
        },
        {
          text: this.$t('Templates'),
          component: 'block-admin-templates',
          componentProps: {
            entityId: this.user.id,
            filterName: 'user.id'
          }
        },
        {
          text: this.$t('Tags'),
          component: 'block-user-tags',
          componentProps: {
            userId: this.user.id
          }
        },
        {
          text: this.$t('Organizations'),
          component: 'block-user-organizations',
          componentProps: {
            userId: this.user.id
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss"></style>
